// extracted by mini-css-extract-plugin
module.exports = {"text":"DriverOrdersDetails_text__15kr3","tooltip":"DriverOrdersDetails_tooltip__2OIcK"};